import Vue from 'vue'
import App from './app/index.vue'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'
import Maska from 'maska'
import money from 'v-money'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BootstrapVue from 'bootstrap-vue'

Vue.config.productionTip = false

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)
Vue.use(VueTheMask)
Vue.use(Maska)
Vue.use(money, { precision: 2 })

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
